"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") {
		for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: () => from[key],
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useQuery_exports = {};
__export(useQuery_exports, { useQuery: () => useQuery });
module.exports = __toCommonJS(useQuery_exports);
var import_react = require("react");
var import_one_server_only = require("../vite/one-server-only");
var import_getQueryKey = require("./getQueryKey");
require("./resolveQuery");
var import_useQueryZero = require("./useQueryZero");
var _getServerContext;
var clientInitialData = (_getServerContext = (0, import_one_server_only.getServerContext)()) === null || _getServerContext === void 0 ? void 0 : _getServerContext.postRenderData;
var serverQueryData = {};
globalThis["__vxrnServerData__"] = serverQueryData;
var useQuery = function useQuery2(query) {
	var enable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
	var snapshot = (0, import_useQueryZero.useQuery)(query, enable);
	var queryIdRef = (0, import_react.useRef)(void 0);
	if (query && !queryIdRef.current) queryIdRef.current = (0, import_getQueryKey.getQueryKey)(query);
	var queryId = queryIdRef.current || "";
	if (clientInitialData && !snapshot) return clientInitialData[queryId] || [];
	return snapshot || [];
};
//# sourceMappingURL=useQuery.js.map
